module.exports = __webpack_public_path__ + "media/application/images/2023/05_still-925x520-477f501fe9c0da3e971922bcf4329251.png";